import {
  AlertTriangle,
  CheckCircle,
  Clock,
  AlertCircle,
} from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { formatRuDate } from '@/lib/dateFmt';

type AccessState = 'active' | 'trial' | 'grace' | 'restricted' | 'suspended';

export interface AccessStateInfo {
  state: AccessState;
  until?: string | null;
}

/**
 * Банер состояния доступа тенанта (AK-6).
 * Mirrors frontend/src/components/AccessStateBanner.tsx 1:1 в smaslе UX.
 */
export function AccessStateBanner({ info }: { info: AccessStateInfo | null }) {
  if (!info) return null;
  const { state, until } = info;
  if (state === 'active') return null;

  const dateLabel = until ? formatRuDate(until) : null;

  switch (state) {
    case 'trial':
      return (
        <Alert variant="info" className="rounded-none border-x-0 border-t-0">
          <Clock className="h-4 w-4" />
          <AlertDescription>
            Тестовый доступ{' '}
            {dateLabel ? (
              <>
                до <strong>{dateLabel}</strong>
              </>
            ) : null}
          </AlertDescription>
        </Alert>
      );
    case 'grace':
      return (
        <Alert variant="warning" className="rounded-none border-x-0 border-t-0">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Оплата просрочена.{' '}
            {dateLabel ? (
              <>
                Продлите до <strong>{dateLabel}</strong>,{' '}
              </>
            ) : (
              ''
            )}
            иначе работа будет ограничена.
          </AlertDescription>
        </Alert>
      );
    case 'restricted':
      return (
        <Alert variant="warning" className="rounded-none border-x-0 border-t-0">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>
            Работа ограничена — только просмотр.{' '}
            {dateLabel ? (
              <>
                Продлите оплату до <strong>{dateLabel}</strong>,{' '}
              </>
            ) : (
              ''
            )}
            иначе доступ будет приостановлен.
          </AlertDescription>
        </Alert>
      );
    case 'suspended':
      return (
        <Alert
          variant="destructive"
          className="rounded-none border-x-0 border-t-0"
        >
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>
            Доступ к компании приостановлен. Обратитесь к администратору.
          </AlertDescription>
        </Alert>
      );
  }

  return (
    <Alert variant="info" className="rounded-none border-x-0 border-t-0">
      <CheckCircle className="h-4 w-4" />
      <AlertDescription>Состояние доступа: {state}</AlertDescription>
    </Alert>
  );
}

export default AccessStateBanner;
